import { render, staticRenderFns } from "./AssistantList.vue?vue&type=template&id=f32c6194&scoped=true&"
import script from "./AssistantList.vue?vue&type=script&lang=js&"
export * from "./AssistantList.vue?vue&type=script&lang=js&"
import style0 from "./AssistantList.vue?vue&type=style&index=0&id=f32c6194&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c6194",
  null
  
)

export default component.exports